<template>
  <div class="login_container">
    <div class="login_box">
        <!-- <div class="avatar_box">
            <img src="../assets/logo.png" alt="">
        </div> -->
        <el-form :model="loginForm" :rules="rules" name="loginForm"
         ref="loginForm" label-width="50px" class="demo-ruleForm login-page">
            <h3 class="title">系统登录</h3>
            <el-form-item prop="uname" label="账号">
                <el-input type="text" blur=""
                    v-model="loginForm.uname"
                    auto-complete="off"
                    placeholder="用户名"
                ></el-input>
            </el-form-item>
            <el-form-item prop="passwd" label="密码">
                <el-input type="password" v-model="loginForm.passwd" auto-complete="off"
                    placeholder="密码"
                ></el-input>
            </el-form-item>
            <!-- <el-form-item label-width="0">
              <el-checkbox v-model="checked" class="rememberme">记住密码</el-checkbox>
            </el-form-item> -->
            <el-form-item label-width="0">
                <el-button type="primary" style="width:100%;" @click="handleLogin" :loading="logining">登录</el-button>
            </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      logining: false,
      loginForm: {
          uname: '',
          passwd: ''
      },
      rules: {
          uname: [{required: true, message: '请输入用户名!', trigger: 'blur'}],
          passwd: [{required: true, message: '请输入密码!', trigger: 'blur'}]
      },
      checked: false
    }
  },
  mounted () {
    localStorage.removeItem('user')
     window.addEventListener('keydown', this.keyDown)
  },
  methods: {
    handleLogin () {
      var isValid = false
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          isValid = true
        }
      })
      if (!isValid) {
        return
      }
      this.logining = true
      this.$http.postData('/api/admin/user/login', {
        'uname': this.loginForm.uname,
        'passwd': this.$md5(this.loginForm.passwd)
      }).then(response => {
        if (response.code === 'SUCCESS') {
          localStorage.setItem('user', JSON.stringify(response))
          localStorage.setItem('menus', JSON.stringify(response.menus))
          if (response.type === this.$enum.userType.saleUser || response.type === this.$enum.userType.saleAideUser) {
            this.$router.push('/order/')
          } else if (response.type === this.$enum.userType.serviceUser) {
            this.$router.push('/order/listDeliver')
          } else {
            this.$router.push('/')
          }
        } else {
          this.$alert(response.desc)
        }
        this.logining = false
      })
    },
    keyDown (e) {
      if (e.keyCode === 13) {
        this.handleLogin()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.login_container {
    height: 100%;
    // background-color: #2b4b6b;
    background-color: #545c64;
}
.login_box{
    width: 450px;
    height: 300px;
    background-color: #fff;
    border-radius: 3px;
    position: absolute;
    left: 50%;
    top:50%;
    transform: translate(-50%,-50%);
    padding: 10px 40px;
}
/* 头像样式开始 */
.avatar_box{
        height: 130px;
        width: 130px;
        border: 1px solid #eee;
        border-radius: 50%;
        padding: 10px;
        box-shadow: 0 0 10px #ddd;
        position: absolute;
        left:50%;
        transform: translate(-50%,-50%);
        background-color: #fff;
    }
.avatar_box img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background-color: #eee;
        }
/* 头像样式结束 */

.btns{
/*     position: absolute;
    right: 0; */
    display: flex;
    justify-content: flex-end;
    }
.login_form{
    position: absolute;
    bottom: 0;
    /* 占满全屏 */
    width: 100%;
    /* 边距会超出 用后面那句 box-sizing: border-box; */
    padding: 0 20px;
    box-sizing: border-box;
}
.title {
  padding-bottom: 30px;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue